import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import logo from '../assets/logo-centrao.png';

export default function Header() {
  const { user, logout } = useAuth();
  const location = useLocation();
  const naHome = location.pathname === '/';

  return (
    <header className="header">
      <div className="header-left">
        {!naHome && (
          <Link to="/" className="btn-voltar" title="Voltar ao início">
            <i className="bi bi-arrow-left"></i>
            <span>Início</span>
          </Link>
        )}
        <Link to="/" className="header-logo-link" style={{ display: 'flex', alignItems: 'center', textDecoration: 'none' }}>
          <img src={logo} alt="Centrão" className="logo" />
        </Link>
      </div>
      <div className="user-info">
        Olá, <strong>{user?.nome}</strong>
        <Link to="/trocar-senha" className="btn-senha" title="Trocar minha senha">
          <i className="bi bi-key"></i><span>Trocar senha</span>
        </Link>
        <button className="btn-sair" onClick={logout}>Sair</button>
      </div>
    </header>
  );
}
